module.exports = __webpack_public_path__ + "img/erp_service2.05be0bad.png";